import {connect} from 'react-redux';
import {push} from 'react-router-redux/lib/actions';
import {STREAM_ROUTER_ROOT} from '../constants';
import CreateNewComponent from './StreamEdit';
import {streamAction} from '../../../../actions/stream/customStream';

// new way of actions. Has to have less memory in use;
let CRUDActions = streamAction;

export default connect(
  ({customStream: {loadingItem, model}}) => ({
    model,
    title: 'Edit Stream',
    loading: loadingItem
  }),
  dispatch => ({
    fetch: (id) => dispatch(CRUDActions.fetch(id)),
    goIndex: () => dispatch(push(STREAM_ROUTER_ROOT))
  })
)(CreateNewComponent)





// WEBPACK FOOTER //
// ./src/components/Stream/CustomStream/StreamEdit/index.js